export const environment = {
    production: false,
    bitbucketSource: 'https://bitbucket.org/metrics-test/',
    baseUrl: 'https://11vi8vyl44.execute-api.ap-south-1.amazonaws.com',
    jiraBaseUrl: 'https://3znje7eqrk.execute-api.ap-south-1.amazonaws.com',
    projectBaseUrl: 'https://cu1azpqty2.execute-api.ap-south-1.amazonaws.com',
    springBootUrl: 'https://dev-api.metrics.mindbowser.com/api/v1',
    bucketName: 'metrics-sproutops-bucket',
    jirasyncBaseUrl:
        ' https://us773ifzr2h6ih5h4imvu5sspy0ixbhc.lambda-url.ap-south-1.on.aws',
    GoogleClientId:
        '634085334801-2qo990of3dib17r84cdqa1rn2h5ur0ju.apps.googleusercontent.com',
    firebaseConfig: {
        apiKey: 'AIzaSyAINQqjeIGjKSoFjlyb0lZUDT6LrPx3B_M',
        authDomain: 'metrics-dev-acdc5.firebaseapp.com',
        databaseURL: 'https://metrics-dev-acdc5-default-rtdb.firebaseio.com',
        projectId: 'metrics-dev-acdc5',
        storageBucket: 'metrics-dev-acdc5.appspot.com',
        messagingSenderId: '154633398807',
        appId: '1:154633398807:web:6601a32fe33ce8f9118a52',
        measurementId: 'G-TQMZ0ZKWYM',
    },
    csvTemplateUrl:
        'https://metrics-sproutops-bucket.s3.ap-south-1.amazonaws.com/resources-csv/template/resources-bulk-upload.csv',
    appUrl: 'https://dashboard.dev.mindbowser.com'};
